import { render, staticRenderFns } from "./AddRoomModal.vue?vue&type=template&id=5723d23a&scoped=true&"
import script from "./AddRoomModal.vue?vue&type=script&lang=js&"
export * from "./AddRoomModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5723d23a",
  null
  
)

export default component.exports